/**
 * Valid email address regex, as defined by [RFC 822](https://owasp.org/www-community/OWASP_Validation_Regex_Repository),
 * which intentionally omits some, technically valid, but often unsupported characters.
 */

export const RFC822_VALID_EMAIL_REGEX =
    /^[a-zA-Z0-9_+&*'-]+(?:\.[a-zA-Z0-9_+&*'-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
/**
 * Verifies URL is in a valid format.
 * @param url The URL (string) to verify
 * @returns `true` if valid, else `false`
 */
export const isUrlValid = (url: string) => {
    try {
        const parsedUrl = new URL(url);
        let encodedUrlStr = parsedUrl.href;

        if (encodedUrlStr.endsWith('/') && !url.endsWith('/')) {
            encodedUrlStr = encodedUrlStr.slice(0, encodedUrlStr.length - 1);
        }
        if (url !== encodedUrlStr) {
            // The string could be URL-encoded to be valid, but wasn't
            // verbatim-valid
            return false;
        }
    } catch {
        return false;
    }
    return true;
};

// 51d52cf1-83c9-4f02-b117-703ecb728b74
//        8    4    4    4           12
const HEX = '[0-9a-f]';
export const GUID_VALID_REGEX = new RegExp(
    `^${HEX}{8}-${HEX}{4}-${HEX}{4}-${HEX}{4}-${HEX}{12}$`,
    'i',
);

/**
 * Takes a value and returns true if the value is a GUID.
 * @param value
 * @returns `true` if valid GUID
 */
export const isValidGuid = (value: string): boolean => GUID_VALID_REGEX.test(value);
